import { render, staticRenderFns } from "./JjEmpty.vue?vue&type=template&id=030b0cfa&scoped=true"
import script from "./JjEmpty.vue?vue&type=script&lang=js"
export * from "./JjEmpty.vue?vue&type=script&lang=js"
import style0 from "./JjEmpty.vue?vue&type=style&index=0&id=030b0cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b0cfa",
  null
  
)

export default component.exports